const studioLink = document.querySelector('.js-studio-link');
const talksLink = document.querySelector('.js-talks-link');
const workshopLink = document.querySelector('.js-workshops-link');

const studioDestination = document.querySelector('#js-studio-destination');
const talksDestination = document.querySelector('#js-talks-destination');
const workshopDestination = document.querySelector('#js-workshops-destination');

if (typeof studioLink != "undefined" && studioLink != null) {

    studioLink.addEventListener('click', () => {
        gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo: studioDestination});
    });
}

if (typeof talksLink != "undefined" && talksLink != null) {

    talksLink.addEventListener('click', () => {
        gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo: talksDestination});
    });
}

if (typeof workshopLink != "undefined" && workshopLink != null) {

    workshopLink.addEventListener('click', () => {
        gsap.to(window, {duration: 0.6, ease: "power4.easeInOut", scrollTo: workshopDestination});
    });
}